import Immutable from 'seamless-immutable';

import { actions } from './actions';
import { collaboratorPagination } from '../../utils/propTypes';

import {
  findUser, cancelStartIn, deleteIn, cancelFailIn, BASE_STATE,
} from './utils';

const defaultState = {
  admins: { ...BASE_STATE },
  editors: { ...BASE_STATE },
  guests: { ...BASE_STATE },
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.LOAD_ADMINS_START: {
      const { page, search } = action.payload;
      return state.merge({
        admins: state.admins.merge({
          page,
          search,
          loading: true,
        }),
      });
    }
    case actions.LOAD_ADMINS_SUCCESS: {
      const {
        page, totalPages, admins: list, total, limit,
      } = action.payload;
      return state.merge({
        admins: state.admins.merge({
          page,
          totalPages,
          list,
          total,
          limit,
          loading: false,
          error: null,
        }),
      });
    }
    case actions.LOAD_ADMINS_FAIL: {
      const { error } = action.payload;
      return state.merge({
        admins: state.admins.merge({
          error,
          list: null,
          loading: false,
        }),
      });
    }
    case actions.LOAD_EDITORS_START: {
      const { page, search } = action.payload;
      return state.merge({
        editors: state.editors.merge({
          page,
          search,
          loading: true,
        }),
      });
    }
    case actions.LOAD_EDITORS_SUCCESS: {
      const {
        page, totalPages, editors: list, total, limit,
      } = action.payload;
      return state.merge({
        editors: state.editors.merge({
          page,
          totalPages,
          list,
          total,
          limit,
          loading: false,
          error: null,
        }),
      });
    }
    case actions.LOAD_EDITORS_FAIL: {
      const { error } = action.payload;
      return state.merge({
        editors: state.editors.merge({
          error,
          list: null,
          loading: false,
        }),
      });
    }
    case actions.LOAD_GUESTS_START: {
      const { page, search } = action.payload;
      return state.merge({
        guests: state.guests.merge({
          page,
          search,
          loading: true,
        }),
      });
    }
    case actions.LOAD_GUESTS_SUCCESS: {
      const {
        page, totalPages, guests: list, total, limit,
      } = action.payload;
      return state.merge({
        guests: state.guests.merge({
          page,
          totalPages,
          list,
          total,
          limit,
          loading: false,
          error: null,
        }),
      });
    }
    case actions.LOAD_GUESTS_FAIL: {
      const { error } = action.payload;
      return state.merge({
        guests: state.guests.merge({
          error,
          list: null,
          loading: false,
        }),
      });
    }
    case actions.CANCEL_START: {
      const { id } = action.payload;
      const { admin, editor, guest } = findUser(id, state);
      let newState = cancelStartIn(state, admin, 'admins');
      newState = cancelStartIn(newState, editor, 'editors');
      newState = cancelStartIn(newState, guest, 'guests');
      return newState;
    }
    case actions.CANCEL_SUCCESS: {
      const { id } = action.payload;
      const { admin, editor, guest } = findUser(id, state);
      let newState = deleteIn(state, admin, 'admins');
      newState = deleteIn(newState, editor, 'editors');
      newState = deleteIn(newState, guest, 'guests');
      return newState;
    }
    case actions.CANCEL_FAIL: {
      const { id } = action.payload;
      const { admin, editor, guest } = findUser(id, state);
      let newState = cancelFailIn(state, admin, 'admins');
      newState = cancelFailIn(newState, editor, 'editors');
      newState = cancelFailIn(newState, guest, 'guests');
      return newState;
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

export const propTypes = {
  admins: collaboratorPagination,
  editors: collaboratorPagination,
  guests: collaboratorPagination,
};



// WEBPACK FOOTER //
// ./src/redux/Collaborators/reducer.js